import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: '属性',

  // 選択サービス名
  serviceName: null,

  // model
  attributeTypeModel: []
}

const getters = {
  get: state => state
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {attributeTypeParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['serviceAttributeType'],
        ['v1ServiceAttributeTypeListGet'],
        [attributeTypeParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setServiceName', res[0].data.serviceName)
            commit('setAttributeTypeModel', res[0].data.serviceAttributeTypes)
            console.log('attributeTypeModel', state.attributeTypeModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  }
}

const mutations = {
  // service name
  setServiceName (state, str) {
    state.serviceName = str
  },
  
  // model
  setAttributeTypeModel (state, data) {
    Vue.set(state, 'attributeTypeModel', data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
